// This file contains constants related to Pendo Tracking Id's used in VCCP application.
const PENDO_LINK_ID = {
    REVEAL_LINK : "reveal-link",
    REDBALL_EMAIL_LINK : "redball-email-link"
}

export default PENDO_LINK_ID;